import { render, staticRenderFns } from "./IndexerDetail.vue?vue&type=template&id=a9ef63be&scoped=true"
import script from "./IndexerDetail.vue?vue&type=script&lang=js"
export * from "./IndexerDetail.vue?vue&type=script&lang=js"
import style0 from "./IndexerDetail.vue?vue&type=style&index=0&id=a9ef63be&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9ef63be",
  null
  
)

export default component.exports